"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import vLogo from "../components/images/vilva-new-logo-white.webp";

const PRODUCTS = [
  {
    name: "Vilva ERP",
    tagline: "Run Your Business Smarter",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    name: "Online Commerce",
    tagline: "Sell Anywhere, Anytime",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: "Business Websites",
    tagline: "Build a Powerful Digital Presence",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <path d="M2 12H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    name: "Visual Marketing",
    tagline: "Turn Attention into Revenue",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: "Vilva Chat",
    tagline: "Automate Conversations & Sales",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    name: "Growth Ecosystem",
    tagline: "One Unified Digital Stack",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M12 22C12 17.5817 15.5817 14 20 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 22C12 17.5817 8.41828 14 4 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 22V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="5" r="3" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
];

const HIGHLIGHTS = [
  { value: "6+", label: "Products" },
  { value: "40%", label: "Commission" },
  { value: "50+", label: "Partners" },
];

export const PartnerRightSec = () => {
  return (
    <div className="h-full flex flex-col justify-between gap-4">
      {/* Logo */}
      <div>
        <Link href="/">
          <Image src={vLogo} alt="Vilva Business Logo" className="w-[130px] mx-auto mb-5" />
        </Link>

        {/* Hero headline */}
        <div className="mb-5">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-[#31E0FF] animate-pulse flex-shrink-0" />
            <span
              className="text-[#31E0FF] text-[11px] tracking-[0.3em] uppercase"
              style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}
            >
              Partner Ecosystem
            </span>
          </div>
          <h2
            className="text-white text-[22px] font-bold leading-[1.2] mb-2"
            style={{ fontFamily: "NeueMontreal, sans-serif" }}
          >
            Everything You Need to{" "}
            <span style={{ color: "#31E0FF" }} className="font-NeueMontreal">Grow Digitally</span>
          </h2>
          <p
            className="text-white/55 text-[12px] leading-relaxed"
            style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}
          >
            Resell, white-label, or integrate our full suite of products — and earn recurring revenue as a Vilva partner.
          </p>
        </div>

        {/* Highlights row */}
        <div className="flex gap-2 mb-5">
          {HIGHLIGHTS.map((h, i) => (
            <div
              key={i}
              className="flex-1 text-center rounded-[12px] border border-white/[0.12] bg-white/[0.06] py-2.5"
            >
              <div
                className="text-white text-[20px] font-bold leading-none mb-0.5"
                style={{ fontFamily: "NeueMontreal, sans-serif" }}
              >
                {h.value}
              </div>
              <div
                className="text-white/45 text-[10px]"
                style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}
              >
                {h.label}
              </div>
            </div>
          ))}
        </div>

        {/* Product list */}
        <div className="space-y-2">
          <p
            className="text-white/40 text-[10px] tracking-[0.25em] uppercase mb-1"
            style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}
          >
            Our Product Suite
          </p>
          {PRODUCTS.map((p, i) => (
            <div
              key={i}
              className="flex items-center gap-3 rounded-[12px] border border-white/[0.08] bg-white/[0.05] px-3.5 py-2.5 hover:bg-white/[0.10] transition-colors duration-200"
            >
              <div className="w-8 h-8 rounded-lg bg-[#195AFF]/20 flex items-center justify-center text-[#31E0FF] flex-shrink-0">
                {p.icon}
              </div>
              <div className="min-w-0">
                <div
                  className="text-white text-[13px] font-medium leading-tight"
                  style={{ fontFamily: "NeueMontreal, sans-serif" }}
                >
                  {p.name}
                </div>
                <div
                  className="text-white/40 text-[11px] truncate"
                  style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}
                >
                  {p.tagline}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="mt-auto pt-3">
        <div className="flex items-center justify-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse flex-shrink-0" />
          <span
            className="text-white/50 text-[11px]"
            style={{ fontFamily: "Schibsted Grotesk, sans-serif" }}
          >
            50+ Active Partners Worldwide
          </span>
        </div>
      </div>
    </div>
  );
};
